'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _detectEnv = require('acq-utils-environments/lib/detect-env');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (ProxyAgent) {
  if (!ProxyAgent) {
    return undefined;
  }
  var env = (0, _detectEnv.getEnv)();
  if (env === 'e0') {
    return undefined;
  }
  var proxyHost = {
    e1: 'http://PHXAPPGWE2-VIP.phx.aexp.com:9090',
    e2: 'http://PHXAPPGWE2-VIP.phx.aexp.com:9090',
    e3: 'http://proxy-appgw.aexp.com:9090'
  }[env];
  var proxyUrl = _url2.default.parse(proxyHost);
  proxyUrl.secureProxy = proxyUrl.protocol === 'https:';
  return new ProxyAgent(proxyUrl);
};